import { render, staticRenderFns } from "./documentStatusDialog.vue?vue&type=template&id=621a1a67&scoped=true&"
import script from "./documentStatusDialog.vue?vue&type=script&lang=js&"
export * from "./documentStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./documentStatusDialog.vue?vue&type=style&index=0&id=621a1a67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a1a67",
  null
  
)

export default component.exports